import React from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import ContentLoading from 'Components/ComponentLibrary/Molecules/ContentLoading';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import ActivationActions
  from './ActivationActions';

const Container = ({ resource, onActionClick, showAction }) => {
  const {
    isInitializing,
    relationshipRefreshError,
  } = useIncludedRelationshipContext();

  return (
    <DataContainer
      component={ActivationActions}
      componentProps={{
        resource,
        onActionClick,
        showAction,
      }}
      loading={isInitializing}
      loadingError={relationshipRefreshError}
      skeleton={ContentLoading}
    />
  );
};

Container.propTypes = {
  resource: PropTypes.object.isRequired,
  onActionClick: PropTypes.func.isRequired,
  showAction: PropTypes.func.isRequired,
};

export default Container;
